export default __webpack_public_path__ + "static/media/Book5.f700213c.webp";